import Seo from "../components/Seo";
import Section from "../components/ui-custom/Section";
import AboutStory from "../components/sections/AboutStory";
import Features from "../components/sections/Features";
import CTA from "../components/sections/CTA";
import PageHeader from "../components/ui-custom/PageHeader";

export default function About() {
  return (
    <>
      <Seo title="About" description="utipanagecy helps retailers grow their digital business through automation, speed, transparency and technology." />
      <PageHeader eyebrow="About Us" title="The platform behind India's retailers" sub="We focus on automation, speed, transparency and technology." />
      <Section testId="about-page">
        <AboutStory />
      </Section>
      <Section eyebrow="Our Values" heading="What drives us every day" testId="about-features">
        <Features />
      </Section>
      <CTA />
    </>
  );
}
